export default "__VITE_ASSET__CS_fTBIZ__"